/* eslint-disable max-len */
// noinspection CssUnusedSymbol

import {COMMON_PDF_CSS} from './common-report-css';

// language=CSS
export const BUSINESS_PDF_CSS = COMMON_PDF_CSS + `
  /*! Business CSS Fragment */
  body {
    font-size: 0.9rem;
  }
  
  *, ::after, ::before {
    text-shadow: none !important;
    box-shadow: none !important;
  }

  hr {
    background-color: grey !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    border-top: 1px solid rgba(0, 0, 0, .1);
    border: 0;
    box-sizing: content-box;
    height: 1px;
    margin-bottom: 1rem;
    margin-top: 1rem;
    overflow: visible;
  }

  h2, h3, h4 {
    margin-bottom: .5rem;
    line-height: 1.2;
    font-weight: bold;
  }

  h2 {
    font-size: 1.5rem;
    margin-top: 1.5rem;
  }

  .title-bar h2, h3, h4 {
    margin-top: 0
  }
  
  h3 {
    font-size: 1.25rem;
  }

  h4 {
    font-size: 1.15rem;
    font-family: Arial, sans-serif;
    margin-bottom: 0;
  }

  .d-block.d-md-none,
  .d-block.d-lg-none,
  .d-none.d-xl-flex {
    display: none !important;
  }

  /* START Flex Rules */

  .row,
  [class^=col-].row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: 0;
    margin-left: 0;
  }

  .col, .col-sm, .col-md, .col-lg,
  [class*=col-sm-].col-md,
  [class*=col-sm-].col-lg,
  [class*=col-md-].col-lg,
  [class*=col-sm-][class*=col-md-].col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  
  .col-10, .col-12, .col-2, .col-3, .col-4, .col-6, .col-8,
  .col-lg, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1,
  .col-md, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1,
  .col-sm, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1 {
    position: relative;
    width: 100%;
  }

  .col-6.col-md-1 {
    flex: 0 0 8% !important;
    max-width: 8% !important;
  }

  .col-2,
  .col-sm-2,
  .col-md-2,
  .col-sm-6.col-md-3.col-lg-2,
  .col-sm-6.col-lg-2,
  .col-md-3.col-lg-2,
  .col-lg-2,
  .col-6.col-md-2,
  .col-sm-12.col-md-2,
  .col-sm-6.col-md-2 {
    flex: 0 0 16%;
    max-width: 16%;
  }

  .col-3,
  .col-sm-3,
  .col-md-3,
  .col-lg-3,
  .col-sm-12.col-md-6.col-lg-3,
  .col-sm-6.col-md-3 {
    flex: 0 0 24%;
    max-width: 24%;
  }

  .col-4,
  .col-sm-4,
  .col-sm-12.col-md-4,
  .col-sm-12.col-md-6.col-lg-4,
  .col-sm-12.col-md-9.col-lg-4,
  .col-sm-12.col-lg-4,
  .col-md-9.col-lg-4,
  .col-sm-6.col-md-3.col-lg-4,
  .col-sm-6.col-lg-4,
  .col-md-3.col-lg-4,
  .col-lg-4 {
    flex: 0 0 32%;
    max-width: 32%;
  }

  .col-lg-5 {
    flex: 0 0 40%;
    max-width: 40%;
  }

  .col-6,
  .col-12.col-lg-6,
  .col-sm-12.col-md-6,
  .col-sm-12.col-lg-6,
  .col-sm-6,
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }

  .col-8 {
    flex: 0 0 64%;
    max-width: 64%;
  }

  .col-12.col-md-9,
  .col-md-9 {
    flex: 0 0 72%;
    max-width: 72%;
  }

  .col-10,
  .col-lg-10 {
    flex: 0 0 80%;
    max-width: 80%;
  }

  .col-12,
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .col.pdf-reactor-5,
  .col-sm.pdf-reactor-5,
  .col-md.pdf-reactor-5,
  .col-lg.pdf-reactor-5 {
    flex: 0 0 19.2% !important;
    max-width: 19.2% !important;
  }

  .col.pdf-reactor-7,
  .col-sm.pdf-reactor-7,
  .col-md.pdf-reactor-7,
  .col-lg.pdf-reactor-7 {
    flex: 0 0 13.7% !important;
    max-width: 13.7% !important;
  }
  /* END Flex Rules */


  /* Custom CSS */
  .content-main-title {
    display: none;
  }

  div.title, h2:not(.content-main-title) {
    border-bottom: 1px dotted rgba(147, 147, 147, 0.5);
  }

  div.title {
    margin-bottom: 5px;
  }

  h3.tile-title {
    border-bottom: 1px dotted rgba(147, 147, 147, 0.5);
    font-size: 1.2em;
    line-height: 1.5em;
    width: 100%;
  }

  .building-icon {
    width: 37px;
    height: 36px;
  }

  div.credit-report * {
    margin-left: 0;
    margin-right: 0;
  }

  div.credit-report [class^=col-] {
    padding-left: 0;
    padding-right: 0;
  }

  div.credit-report > .row {
    border-bottom: 2px solid grey;
  }

  div.credit-report h4, div.credit-report .business-report-value {
    font-size: 0.95em;
  }

  div.credit-report .credit-report-image-bg .business-report-summary-tile div.justify-content-center {
    justify-content: unset !important;
  }

  div.credit-report .header-date-info {
    font-size: 0.8em;
  }

  div.credit-report .title-bar {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
  }

  div.credit-report .title-bar.blue {
    background-color: #0295be !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  div.credit-report .title-bar * {
    width: 100%;
    line-height: 0.9em;
  }

  div.credit-report .title-bar .title {
    font-size: 2em;
  }

  div.credit-report .title-bar .subtitle {
    font-size: 1.5em;
    font-weight: 400;
    margin-bottom: 0;
  }

  div.credit-report .business-report-content:not(.business-identification-information) h3 {
    font-size: 1.2em;
    padding-top: 5px;
  }

  div.credit-report .business-report-content .report-labelled-cell .label {
    font-weight: 500;
  }

  div.credit-report .indented-report-subsection.grey {
    border-left: 20px solid #ddd;
    border-top: 5px solid #ddd;
    margin-top: 5px;
    margin-bottom: 10px;
  }

  div.credit-report .indented-report-subsection.orange {
    border-left: 20px solid #fcd800;
    border-top: 5px solid #fcd800;
    margin-top: 5px;
    margin-bottom: 10px;
  }

  div.credit-report .indented-report-subsection.green {
    border-left: 20px solid #a9d161;
    border-top: 5px solid #a9d161;
    margin-top: 5px;
    margin-bottom: 10px;
  }

  div.credit-report .indented-report-subsection.red {
    border-left: 20px solid #e14025;
    border-top: 5px solid #e14025;
    margin-top: 5px;
    margin-bottom: 10px;
  }

  div.credit-report .lumbermans-detail-row {
    border-bottom: 1px solid grey;
    margin-bottom: 10px;
    font-size: .75rem; /* This is the only way to make it reliably fit and be legible in the PDF */
  }

  /* Force the first section to be a column and switch the business ID info and credit score sections */
  .pdf-reactor-column {
    border-bottom: 2px solid grey;
    flex-flow: column !important;
  }

  .pdf-reactor-column > div:nth-child(2) {
    flex: 0 0 100%;
    max-width: 100%;
    /*order: 1;*/
  }
  
  /*.pdf-reactor-column > div:nth-child(1) {
    flex: 0 0 100%;
    max-width: 100%;
    order: 2;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  */

  div.credit-report .credit-report-image-bg > .row {
    flex-flow: column !important;
  }

  div.credit-report .credit-report-image-bg .business-report-summary-tile {
    flex-flow: column;
    flex: 0 0 100%;
    max-width: 100%;
  }

  div.credit-report .credit-report-image-bg .business-report-summary-tile .tile-title {
    flex: 0 1 auto;
  }

  .logo-appcard {
    padding-bottom: 1rem;
  }

  /* Sidecard styling */
  /*.card-title {
      width: 100%;
      border-bottom: 1px dashed grey;
  }
  
  .card-body {
      border: 1px solid grey;
      padding: 5px;
      margin-bottom: 20px;
      width: 100%;
  }
  
  .sidecard-content {
      flex-flow: row;
      flex-wrap: wrap;
      display: flex;
      width: 100%;
  }
  
  .sidecard-row {
      position: relative;
      width: 100%;
      flex-flow: column;
      flex: 0 0 48%;
      max-width: 48%;
  }
  
  .sidecard-row div:nth-child(1) {
      font-weight: bold;
  }*/
`;
